import React from 'react'
import { StyledHeader, StyledText } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { ProtectedPcImg } from '../Onboarding.styled'
import protectedPc from 'Assets/images/protectedPC.svg'
import { AddSingleDomain } from 'Features/OnboardingWizard/components/FirstDomain/AddDomain/AddSingleDomain'

export const FirstDomain = ({
  onAddDomain,
  addedDomainAddress,
  addedDomainId,
}: {
  onAddDomain: (domainId: number, address: string, isNoTimeout?: boolean) => void
  addedDomainAddress?: string | undefined
  addedDomainId?: number | undefined
}) => {
  const { t } = useTranslation('onboarding')

  return (
    <>
      <StyledHeader variant={'h1'}>{t('add_domain.title1')}</StyledHeader>
      <StyledHeader variant={'h1'}>{t('add_domain.title2')}</StyledHeader>
      <ProtectedPcImg src={protectedPc} alt="protected pc" />
      <StyledHeader variant={'h3'}>{t('add_domain.start_adding_domain')}</StyledHeader>
      <StyledText css={{ marginTop: '$8' }} variant={'baseRegular'}>
        {t('add_domain.last_explainer')}
      </StyledText>
      <AddSingleDomain
        onSuccessCallback={onAddDomain}
        addedDomainAddress={addedDomainAddress}
        addedDomainId={addedDomainId}
      />
    </>
  )
}
